import script from "./FooterPage.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterPage.vue?vue&type=script&setup=true&lang=js"

import "./FooterPage.vue?vue&type=style&index=0&id=17013d68&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17013d68"]])

export default __exports__